'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var useMatchMedia = require('./use-match-media.js');

/**
 * A React hook for detecting `prefers-color-scheme`. Returns `dark`, `light`,
 * or `no-preference` depending on the users OS or browser settings.
 *
 * https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-color-scheme
 *
 * @example const colorScheme = usePrefersColorScheme();
 * @returns PrefersColorScheme
 */ const usePrefersColorScheme = ()=>{
    const dark = useMatchMedia.useMatchMedia('(prefers-color-scheme: dark)');
    const light = useMatchMedia.useMatchMedia('(prefers-color-scheme: light)');
    return dark ? 'dark' : light ? 'light' : 'no-preference';
};

exports.usePrefersColorScheme = usePrefersColorScheme;
//# sourceMappingURL=use-prefers-color-scheme.js.map
